import React from "react";
import "./index.less";
import { Row, Col, Tabs, Empty, div, Steps } from "antd";
import Ksrm from "./ksrm";
import Djal from "./djal";
import RightArrow from "@/assets/images/rightArrow.svg";

function Zntkfpt() {
  return (
    <div className="zntkfpt">
      <div className="content">
        <div className="des">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="listItem hiagent">
                <div className="name">
                  <div className="title">Hiagent</div>
                </div>
                <p className="description">
                  <div>
                    <p>
                      打造企业级、生产级的智能体（Agent）一站式开发与运营平台。深度融合Agentic工作流编排、RAG知识引擎与智能体DevOps全生命周期管理，赋能校园师生高效开发、部署、评测、观测与优化高价值智能体应用。
                    </p>
                  </div>
                  <div
                    style={{
                      paddingTop: "24px",
                    }}
                  >
                    <div
                      style={{
                        padding: "0 12px",
                        border: "1px solid #ccc",
                        width: "120px",
                        textAlign: "center",
                        borderRadius: "10px",
                      }}
                    >
                      登录方式
                    </div>
                    <div
                      style={{
                        padding: "10px 0",
                      }}
                    >
                      <span
                        style={{
                          paddingRight: "8px",
                        }}
                      >
                        输入租户"ZJU"
                      </span>
                      <span>
                        <img
                          style={{
                            width: "16px",
                          }}
                          src={RightArrow}
                          alt=" "
                        />
                      </span>
                      <span
                        style={{
                          padding: "0 8px",
                        }}
                      >
                        点击"SSO登录"
                      </span>
                      <span>
                        <img
                          style={{
                            width: "16px",
                          }}
                          src={RightArrow}
                          alt=" "
                        />
                      </span>
                      <span
                        style={{
                          paddingLeft: "8px",
                        }}
                      >
                        自动跳转至浙大统一身份认证进行登录
                      </span>
                    </div>
                  </div>
                </p>
                <div className="action">
                  <div
                    className="actionEnter actionHiagent"
                    onClick={() => {
                      window.open(
                        "https://open.zju.edu.cn/product/llm/mall/application"
                      );
                    }}
                  >
                    点击进入
                  </div>
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="listItem dify">
                <div className="name">
                  <div className="title">Dify</div>
                </div>
                <p className="description">
                  <div>
                    <p>
                      Dify是一款开源的大模型应用开发平台，旨在帮助开发者快速构建生产级生成式AI应用。其核心功能包括低代码/无代码工作流编排、RAG知识库、Agent智能体框架等，支持数百种开源及商业大模型（如Llama3、GPT-4等）
                      。
                    </p>
                  </div>
                  <div
                    style={{
                      paddingTop: "24px",
                    }}
                  >
                    <div
                      style={{
                        padding: "0 12px",
                        border: "1px solid #ccc",
                        width: "120px",
                        textAlign: "center",
                        borderRadius: "10px",
                      }}
                    >
                      登录方式
                    </div>
                    <div
                      style={{
                        padding: "10px 0",
                      }}
                    >
                      <span
                        style={{
                          paddingRight: "8px",
                        }}
                      >
                        使用邮箱进行登录
                      </span>
                      <span>
                        <img
                          style={{
                            width: "16px",
                          }}
                          src={RightArrow}
                          alt=" "
                        />
                      </span>
                      <span
                        style={{
                          paddingLeft: "8px",
                        }}
                      >
                        账号注册方式：填写<a href="https://form.zju.edu.cn/#/dform/genericForm/2SU4CemZ">账号申请表单</a>，进行账号注册。
                      </span>
                    </div>
                  </div>
                </p>
                <div className="action">
                  <div
                    className="actionEnter actionDify"
                    onClick={() => {
                      window.open("https://dify.zju.edu.cn/");
                    }}
                  >
                    点击进入
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className="wrapContent">
          <div className="tabContent">
            <Tabs
              type="card"
              centered
              items={[
                {
                  label: "快速入门",
                  key: 1,
                  children: <Ksrm />,
                },
                {
                  label: "搭建案例",
                  key: 2,
                  children: <Djal />,
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Zntkfpt;
